import DictionaryApiService from '@/services/api/serverless/addresses/dictionary';
import OptionsHelper from '@/utils/OptionsHelper';

// @vue/component
const AddressDictionaries = {
  data: () => ({
    addressDictionaries: [],
    areAddressDictionariesLoading: false,
  }),
  computed: {
    cities() {
      const cities = this.addressDictionaries.map((addressDictionary) => addressDictionary.city);

      return [...new Set(cities)];
    },
    citiesOptions() {
      return OptionsHelper.mapValuesIntoOptions(this.cities);
    },
    communities() {
      return this.addressDictionaries
        .filter(({ city }) => city === this.city)
        .map(({ community }) => community);
    },
    communitiesOptions() {
      return OptionsHelper.mapValuesIntoOptions(this.communities);
    },
  },
  methods: {
    async getAddressDictionaries(province) {
      this.areAddressDictionariesLoading = true;

      try {
        this.addressDictionaries = await DictionaryApiService.getCitiesByProvince(province);
      } finally {
        this.areAddressDictionariesLoading = false;
      }
    },
  },
};

export default AddressDictionaries;
